import { render } from "./InstructorDetails.vue?vue&type=template&id=404e9080&ts=true"
import script from "./InstructorDetails.vue?vue&type=script&lang=ts"
export * from "./InstructorDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__